<div class="envio-simple-page">
  <h1 class="envio-simple-page__title">Envío simple</h1>

  <app-envio-simple-stepper
    [elementos]="envioSimpleFlowService.PASOS"
    [stepActive]="envioSimpleFlowService.pasoActivo">
  </app-envio-simple-stepper>

  <section class="envio-layout">
    <div class="envio-layout__scroll">
      <article class="envio-seccion">
        <header class="envio-seccion__titulo envio-seccion__titulo--firmantes">
          <div class="envio-seccion__titulo-texto">
            <h2>Firmantes</h2>
            <p class="envio-seccion__subtitulo">Datos de los destinatarios del envío fusionado.</p>
          </div>
          <div class="envio-seccion__titulo-extra"></div>
        </header>
        <div class="envio-seccion__cuerpo">
          <div class="envio-modo-firma" role="radiogroup" aria-label="Modo de firma">
            <div class="input-modo-envio">
              <input
                type="radio"
                id="envio-secuencial"
                name="envioParaleloSimple"
                [checked]="!envioParalelo"
                (change)="establecerEnvioParalelo(false)" />
              <label for="envio-secuencial">Envío secuencial</label>
            </div>
            <div class="input-modo-envio">
              <input
                type="radio"
                id="envio-paralelo"
                name="envioParaleloSimple"
                [checked]="envioParalelo"
                (change)="establecerEnvioParalelo(true)" />
              <label for="envio-paralelo">Envío paralelo</label>
            </div>
          </div>
          <app-envio-simple-firmantes-list
            [canalCorreoActivo]="canalCorreoActivo"
            [canalSMSActivo]="canalSMSActivo"
            [moduloSmsActivo]="moduloSmsActivo"
            [mostrarAvisoCanales]="mostrarAvisoCanales"
            [forzarValidacionContacto]="forzarValidacionContacto"
            [codigosEmailDuplicado]="codigosEmailDuplicado"
            [codigosTelefonoDuplicado]="codigosTelefonoDuplicado"
            [tiposMails]="tiposMails"
            (canalCorreoChange)="toggleCanalCorreo($event)"
            (canalSMSChange)="toggleCanalSMS($event)"
            (ordenMailChange)="cambiarOrdenMail($event)"
            (ordenTelefonoSMSChange)="cambiarOrdenTelefonoSMS($event)"
            (limpiarMarcasEmailDuplicado)="limpiarMarcasEmailDuplicado()"
            (limpiarMarcasTelefonoDuplicado)="limpiarMarcasTelefonoDuplicado()">
          </app-envio-simple-firmantes-list>
        </div>
      </article>

      <app-configura-envio-page class="envio-configura-envio"></app-configura-envio-page>
    </div>
  </section>
</div>

<div class="envio-simple-footer">
  <div class="envio-simple-footer__left">
    <app-boton-accion-secundaria (click)="volver()" [id]="'volver-envio'" [icono]="'hs-arrow-back'" [titulo]="'Volver'"></app-boton-accion-secundaria>
  </div>
  <div class="envio-simple-footer__right botonera-rigth" (click)="onEnviarClick()">
    <app-boton-accion
      [id]="'enviar-envio-simple'"
      [titulo]="'Enviar'"
      [disabled]="!puedeEnviar"
      (botonClicked)="enviar()">
    </app-boton-accion>
  </div>
</div>
